import { LegalLayout, Section } from "@/components/LegalLayout";
import { BUSINESS } from "@/lib/site";

export default function Terms() {
  return (
    <LegalLayout title="Syarat & Ketentuan" subtitle="Terakhir diperbarui: 2026. Dengan menggunakan EventKu, Anda menyetujui ketentuan berikut.">
      <Section title="1. Definisi">
        <p>"Platform" merujuk pada situs dan aplikasi EventKu yang dikelola oleh {BUSINESS.name}. "Pengguna" adalah setiap orang yang mengakses atau bertransaksi di Platform. "Penyelenggara" adalah pihak yang menyelenggarakan acara.</p>
      </Section>
      <Section title="2. Akun Pengguna">
        <p>Pengguna wajib memberikan data yang benar dan akurat saat registrasi. Anda bertanggung jawab menjaga kerahasiaan kredensial akun Anda. Segala aktivitas melalui akun Anda menjadi tanggung jawab Anda.</p>
      </Section>
      <Section title="3. Pembelian & Pembayaran">
        <p>Harga tiket ditampilkan dalam Rupiah (IDR) dan sudah final saat checkout. Pembayaran diproses melalui mitra pembayaran resmi (iPaymu dan/atau Stripe). Tiket baru diterbitkan setelah pembayaran terkonfirmasi sebagai LUNAS.</p>
      </Section>
      <Section title="4. E-Ticket & QR Code">
        <p>Setiap tiket memiliki QR Code dengan token unik. QR Code hanya berlaku untuk satu kali masuk. Dilarang menggandakan, menjual ulang, atau membagikan QR Code. Tiket yang telah dipindai tidak dapat digunakan kembali.</p>
      </Section>
      <Section title="5. Kewajiban Pengguna">
        <p>Pengguna dilarang menggunakan Platform untuk tujuan melanggar hukum, memalsukan tiket, atau merugikan pihak lain. Kami berhak menonaktifkan akun yang melanggar ketentuan ini.</p>
      </Section>
      <Section title="6. Pembatalan & Refund">
        <p>Pembatalan dan pengembalian dana tunduk pada Kebijakan Refund kami. Silakan baca halaman Kebijakan Refund untuk detail syarat dan prosesnya.</p>
      </Section>
      <Section title="7. Batasan Tanggung Jawab">
        <p>{BUSINESS.name} menyediakan Platform sebagai perantara penjualan tiket. Pelaksanaan, kualitas, jadwal, dan isi acara merupakan tanggung jawab Penyelenggara. Kami tidak bertanggung jawab atas kerugian tidak langsung yang timbul di luar kendali kami.</p>
      </Section>
      <Section title="8. Perubahan Ketentuan">
        <p>Kami dapat memperbarui Syarat & Ketentuan ini sewaktu-waktu. Versi terbaru akan selalu tersedia di halaman ini.</p>
      </Section>
      <Section title="9. Hukum yang Berlaku">
        <p>Syarat & Ketentuan ini tunduk pada hukum yang berlaku di Republik Indonesia.</p>
      </Section>
      <Section title="10. Kontak">
        <p>Pertanyaan mengenai ketentuan ini dapat disampaikan ke {BUSINESS.email} atau {BUSINESS.phone}. Alamat: {BUSINESS.address}.</p>
      </Section>
    </LegalLayout>
  );
}
